export default {
  init(a, b) {
    let reference = $(b).data('reference');
    $(a).each(function() {
      let holder = $(this).find('.column__count');
      let count =  holder.data('number');
      let countToPercent = count * 100 / reference;
      holder.animate({height:countToPercent + '%'},1000,function() {
        $(this).addClass('finito');
      });
    });
  },
  count(a) {
    let bar = $('.bar_container__inner'),
    barWidth = 0;
    $(a).each(function(index) {
      let count =  $(this).data('count'),
          $this = $(this);
      if(index == 0) {
        barWidth = count;
      }
      $({ countNum: $this.text()}).animate({
        countNum: count
      },
      {
        duration: 2000,
        easing:'linear',
        step: function() {
          $this.text(Math.floor(this.countNum));
        },
        complete: function() {
          $this.text(this.countNum);
        }
      });  
    });
    
    bar.animate({width:barWidth + '%'},2000,);
  }
}
